import alt from "../alt";
import indexBy from "lodash/keyBy";
import values from "lodash/values";
import extend from "lodash/extend";
import CouponUtil from "../utils/CouponUtil";
import CouponActions from "../actions/CouponActions";
import EventBucketActions from "../actions/EventBucketActions";
import UserStore from "../stores/UserStore";

class CouponStore {
  constructor() {
    this.bindActions(CouponActions);

    this.state = {
      coupons: {},
      couponUses: {},
      newCouponId: null,
      isFetching: false
    };

    this.exportPublicMethods({
      getCouponById: this.getCouponById.bind(this),
      getCouponUsesById: this.getCouponUsesById.bind(this),
      getCouponsForEventBucket: this.getCouponsForEventBucket.bind(this)
    });
  }

  getCouponById(id) {
    return this.state.coupons[id];
  }

  getCouponUsesById(id) {
    return this.state.couponUses[id] || [];
  }

  getCouponsForEventBucket(id) {
    return values(this.state.coupons).filter(function(c) {
      return c.event_bucket === id;
    });
  }

  onFetchOne(id) {
    this.setState({ isFetching: true });
    CouponUtil.fetchOne(UserStore.getState().apiKey, id)
      .then(data => {
        CouponActions.updateCoupon(id, data);
        this.setState({ isFetching: false });
      })
      .catch(CouponActions.fetchFailed);
  }

  onFetchUses(id) {
    this.setState({ isFetchingUses: true });
    CouponUtil.fetchUses(UserStore.getState().apiKey, id)
      .then(data => {
        this.state.couponUses[id] = data;
        this.state.isFetchingUses = false;
        this.setState(this.state);
      })
      .catch(CouponActions.fetchFailed);
  }

  onFetchAllForBucket(eventBucket) {
    this.setState({ isFetching: true });
    CouponUtil.fetchAllForBucket(UserStore.getState().apiKey, eventBucket)
      .then(data => {
        CouponActions.updateCoupons(indexBy(data, "id"));
        this.setState({ isFetching: false });
      })
      .catch(CouponActions.fetchFailed);
  }

  onEdit(newData) {
    CouponUtil.edit(UserStore.getState().apiKey, newData.id, newData.values)
      .then(data => {
        CouponActions.updateCoupon(newData.id, data);
        EventBucketActions.fetchOne(data.event_bucket);
      })
      .catch(CouponActions.editFailed);
  }

  onDelete(id) {
    CouponUtil.delete(UserStore.getState().apiKey, id)
      .then(data => {
        EventBucketActions.fetchOne(this.state.coupons[id].event_bucket);
        CouponActions.updateCoupon(id, undefined);
      })
      .catch(CouponActions.editFailed);
  }

  onCreate(newData) {
    this.setState({
      newCouponId: null
    });

    CouponUtil.create(UserStore.getState().apiKey, newData)
      .then(data => {
        CouponActions.updateCoupon(data.id, data);
        EventBucketActions.fetchOne(data.event_bucket);
        this.setState({
          newCouponId: data.id
        });
      })
      .catch(CouponActions.editFailed);
  }

  onUpdateCoupon(data) {
    if (!data.coupon) {
      delete this.state.coupons[data.id];
    } else {
      this.state.coupons[data.id] = data.coupon;
    }
    this.state.newCouponId = null;
    this.setState(this.state);
  }

  onUpdateCoupons(coupons) {
    extend(this.state.coupons, coupons);
    this.setState(this.state);
  }

  onFetchFailed(e) {
    alert(`Fetching coupon failed: ${e.message}`);
    throw e;
  }

  onEditFailed(e) {
    alert(`Edit failed: ${e.message}`);
    throw e;
  }
}

export default alt.createStore(CouponStore, "CouponStore");



// WEBPACK FOOTER //
// ./src/app/stores/CouponStore.js